/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "ae90f15c3f1fe0e283454ab932e8934940435d94";
